export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-4">桃子影院</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              高清影视在线观看平台，国产剧韩剧美剧全部免费，不缓冲秒开高清超清蓝光4K画质，永久免费看。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2">
              {[
                { label: '精选专题', href: '#index' },
                { label: '热播榜单', href: '#ranking' },
                { label: '重磅推荐', href: '#carousel' },
                { label: '最新动态', href: '#updates' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容分类</h3>
            <div className="flex flex-col gap-2">
              {['国产剧', '韩剧', '美剧', '日剧', '动漫', '综艺', '纪录片'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  onClick={(e) => { e.preventDefault(); scrollTo('#index'); }}
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴信息持续更新中，如有合作意向欢迎通过联系方式与我们取得联系。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:text-accent-400 transition-colors duration-200">
                <i className="ri-wechat-line"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:text-accent-400 transition-colors duration-200">
                <i className="ri-mail-line"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 桃子影院 taozimovie.com - 高清影视在线观看平台
          </p>
          <p className="text-xs text-background-600">
            本站所有内容均来自互联网，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}